document.addEventListener('DOMContentLoaded', function () {
  const partnerLogos = document.querySelector('.partner-logos');
  let autoScrollInterval;
  const scrollAmount = 1; // adjust the scroll amount per tick as needed
  let scrollDirection = 1; // 1 for forward, -1 for backward

  function startAutoScroll() {
    // Stop any existing auto-scroll
    stopAutoScroll();

    // Start a new auto-scroll interval
    autoScrollInterval = setInterval(() => {
      // Check if the end or beginning is reached
      if (scrollDirection === 1 && partnerLogos.scrollLeft >= partnerLogos.scrollWidth - partnerLogos.clientWidth) {
        // Change direction to backward
        scrollDirection = -1;
      } else if (scrollDirection === -1 && partnerLogos.scrollLeft <= 0) {
        // Change direction to forward
        scrollDirection = 1;
      }

      partnerLogos.scrollLeft += scrollAmount * scrollDirection;
    }, 10); // adjust interval as needed
  }

  function stopAutoScroll() {
    if (autoScrollInterval) {
      clearInterval(autoScrollInterval);
    }
  }

  function checkWidthAndScroll() {
    const maxWidth = 52 * 16 - 1; // 52rem - 1px in pixels (assuming 1rem = 16px)
    if (window.innerWidth <= maxWidth) {
      startAutoScroll();
    } else {
      stopAutoScroll();
    }
  }

  // Initial check
  checkWidthAndScroll();

  // Add resize event listener
  window.addEventListener('resize', checkWidthAndScroll);
});
